define('views/pages/ListingPageView',['underscore', 'backbone', 'jquery', 'router', 'app', 'TagCommander',
        'PageView',
        'SubView',
        'template!category',
        'template!listing-layout',
        'template!blocks/listing/navigation-by-desire-dialog',
        'template!blocks/product-block',
        'template!blocks/quantity',
        'template!blocks/cart/offered-products',
        'ProductBlockView',
        'AddressAutocompleteView',
        'views/blocks/ListingMainView',
        'views/blocks/ListingTitleView',
        'views/blocks/ListingMenuView',
        'views/blocks/ListingCartView',
        'views/blocks/ListingDeliveryOptionsView',
        'BtnSwitchView',
        'views/blocks/DateTimeSelectorView',
        'CSS3Events',
        'models/ProductCollection',
        'template!blocks/category-nav-line',
        'BannerMessageView',
        'NoticeMessageView',
        'js-cookie',
        'views/blocks/FiltersView',
    ],
    function (_, Backbone, $, router, app, TagCommander,
              PageView,
              SubView,
              categoryTemplate,
              listingLayoutTemplate,
              navivationByDesireDialogTemplate,
              productBlockTemplate,
              quantityTemplate,
              offeredProductsTemplate,
              ProductBlockView,
              AddressAutocompleteView,
              ListingMainView,
              ListingTitleView,
              ListingMenuView,
              ListingCartView,
              ListingDeliveryOptionsView,
              BtnSwitchView,
              DateTimeSelectorView,
              CSS3Events,
              ProductCollection,
              categoryNavLineTemplate,
              BannerMessageView,
              NoticeMessageView,
              Cookies,
              FiltersView
    ) {

        var view,
            listingMainView,
            listingMenuView,
            listContentEl,
            progressEl,
            category,
            navigationbyDesireCategories,
            menuCategories,
            allCategories = false,
            categoriesEl,
            switchView,
            toggleHeadTimeout,
            autoCloseDialog,
            categoryTracked,
            categoryChangeDelay,categoryChangeTimeout,
            _CATEGORY_CHANGE_MIN_DELAY_ = 1000,
            navigationByDesireAlreadyClicked = false,
            navigationByDesireAlreadySeen = false,
            isNavigationByDesire = false;

        function resetCategoryChangeDelay(){
            categoryChangeDelay = (new Date()).getTime();
        }

        function getCategoryCollection(){
            return isNavigationByDesire ? navigationbyDesireCategories : menuCategories;
        };

        return PageView.extend({
            pageName: 'Listing',
            scrolled: false,
            scrollTop: 0,
            activeCategory: false,
            prevCat: false,
            updateCatEnabled: true,
            initialUpdate: true,
            hideFooter: true,
            periodSwitch: [],
            events: {
                'click .btn-back-to-top': 'backToTop',
                'click .listing-menu .cat-link': 'onCatClick',
                'click .listing-menu .category': 'onChangeNavigationByDesireVisiblity',
                'click .btn-cols': 'toggleProductsSize',
                'mouseenter .listing__navigation-by-desire__block': 'hoverNavigationByDesireDialog',
                'mouseleave .listing__navigation-by-desire__block': 'hoverNavigationByDesireDialog',
                'click .listing__navigation-by-desire__dialog .btn-close': 'closeNavigationByDesireDialog',
                'click .btn-filter': 'openFilters',
            },
            initialize: function (options) {
                //
                // Page Category View
                //

                view = this;
                var id_category = view.$('.product-list').data('category'),
                    allCategoriesCollection = app.getCategories();
                menuCategories = allCategoriesCollection.menuCategories();
                navigationbyDesireCategories = allCategoriesCollection.navigationbyDesireCategories();
                allCategories = !!options.allCategories;

                if (options.link_rewrite || allCategories) {
                    //
                    // microtemplating
                    //
                    if (options.link_rewrite) {
                        category = allCategoriesCollection.findWhere({link_rewrite: options.link_rewrite});
                    }else{
                        category = undefined;
                        allCategories = true;
                    }
                } else {
                    //
                    // classic loading
                    //
                    if (id_category) {
                        category = allCategoriesCollection.findWhere({id_category: id_category.toString()});
                    }else{
                        category = undefined;
                    }
                }

                if(category){
                    isNavigationByDesire = category.isNavigationByDesire();
                }

                // PageView constructor heritage
                PageView.prototype.initialize.apply(view, arguments);
                //

                //
                //
                resetCategoryChangeDelay();


                // default category : the first !
                if((allCategories = !category)) {
                    // var cart = app.getCart();
                    category = getCategoryCollection().firstActiveInContext();
                }

                view.listenTo(app,'listingFilterChange',view.onFilterChange);
                view.render();
                app.set('isListingAllCategories', allCategories);
            },
            onFilterChange:function(e){
                this.$('.btn-filter').attr('data-filters', app.getFiltersChecked());
            },
            //changeContext: function (store) {
            //    this.render();
            //},
            renderContext: function () {
                var view = this, cart = app.getCart();
                app.getProducts().each(function (product) {
                    var isVisible = product.isVisibleInContext(true,cart);
                    view.$('.product-block[data-id_product=' + product.id + ']').toggle(isVisible !== false);
                });
            },
            initialRender: function () {

                var cart = app.getCart();
                view.listenTo(app, 'resize', view.onResize);

                view.listenTo(app, 'scroll', view.onScroll);

                view.listenTo(app, 'listingScrollToCategory', view.onScrollToCategory);
                view.listenTo(app, 'listingCategoryChange', view.onCategoryChange);
                view.listenTo(app, 'listingFilterChange', view.onListingFilterChange);
                // view.listenTo(cart, 'change', view.updateQuantity);
                // view.listenTo(cart, 'removeProduct', view.removeQuantity);
                //view.listenTo(app.getCart(), 'changeContext', this.changeContext);

                view.onResize();
                view.onScroll();

                // Emplacements Messages
                view.attachView(new BannerMessageView('listing_top_banner'));
                view.attachView(new NoticeMessageView('listing_info_bar'));

                if (category) {
                    app.trigger('displayCategory', category.id);
                    setTimeout(function() {
                        view.changeFocusCategory(category.id,false);
                    })
                }

                listingMainView.render();
                listingMenuView.render();

                if (!app.isListingAllCategories()) {
                    view.changeNavigationByDesireVisibility(false)
                }

                view.delegateEvents();

                // affiche la modal d'autocomplete Address si on est sur un pays où c'est configuré ainsi
                if(app.isDeliveryOptionsRequired()){
                    if(!cart.validateDeliveryOptions()){
                        cart.requireDeliveryOptions('all',cart,true);

                    }
                }

                view.toggleNavigationByDesireOnLoad();

            },

            render: function (onlyProducts) {


                var currentCategory = category,isLogged = app.getCustomer().isLogged(), isMobile = app.isMobile();

                var isDisplayFilter = !!parseInt(app.c("_DISPLAY_FILTER_CATALOG_",1));

                var cart = app.getCart();
                var customer = app.getCustomer();
                var categories = getCategoryCollection();
                var isNavigationByDesireActive = view.isNavigationByDesireActive();

                var templateOptions = {
                    isMobile:isMobile,
                    isDisplayFilter:isDisplayFilter,
                    isLogged: isLogged,
                    cart: cart,
                    customer: customer,
                    currentCategory: currentCategory,
                    categories: categories,
                    isNavigationByDesireActive: isNavigationByDesireActive
                }
                //
                // microtemplating full layout
                view.$el.html(listingLayoutTemplate(templateOptions));
                progressEl = view.$('.progress');

                listContentEl = view.$('.list-content');
                listContentEl.on(CSS3Events('transitionend'), view.listingContainerSizeChange);

                function AppendView(constructor, el, options) {
                    return view.appendView(constructor, el, options);
                }

                listingMainView = AppendView(ListingMainView, '.listing-main',  {'isNavigationByDesire': isNavigationByDesire});
                listingMenuView = AppendView(ListingMenuView, '.listing-menu-wrapper');
                var swicthSelectorNavigationByDesire = '.listing__navigation-by-desire'+(isMobile?'--mobile':'')+' .btn-switch';
                if(!isMobile){
                    AppendView(ListingCartView, '.cart-container');
                    AppendView(ListingDeliveryOptionsView, '.delivery-options');

                    AppendView(ListingTitleView, '.listing-title');
                }
                view.$(swicthSelectorNavigationByDesire).each(function () {
                    //
                    // associe la vue BtnSwitch
                    //
                    var switchView = new BtnSwitchView({el:this, checked:isNavigationByDesire});
                    switchView.$el.addClass('navigation-by-desire-switch');

                    view.attachView(switchView);
                    view.listenTo(switchView,'change', view.onChangeNavigationByDesireSwitch);
                });

                // instancie et attache les sous-vues InternalLink
                view.initializeLinksOfPage();


                view.delegateEvents();
            },

            microtemplate: function (options) {
                this.pageOptions = _.defaults(options,{});;
                var targetCategory = getCategoryCollection().findWhere({link_rewrite: options.link_rewrite});
                allCategories = !!options.allCategories;

                app.set('isListingAllCategories', allCategories);

                if (app.isListingAllCategories()) {
                    delete category;
                    app.trigger('displayCategory');
                    this.changeNavigationByDesireVisibility(true)
                } else {
                    view.setCategory(targetCategory);
                    app.trigger('displayCategory', targetCategory.id);
                    this.changeNavigationByDesireVisibility(false)
                }
            },

            onScrollToCategory: function (id_category) {
                view.setCategoryId(id_category);
            },

            getCategory: function () {
                return category;
            },

            setCategory: function (category) {
                view.setCategoryId(category.id);
            },

            setCategoryId: function (id_category) {
                var initialCategory = category,
                    categories = getCategoryCollection();
                category = categories.findWhere({id_category: id_category});
                if (initialCategory != category) {
                    // category change
                    app.trigger('listingCategoryChange', category.id, categories.indexOf(category) > categories.indexOf(initialCategory));
                }
            },
            startPageTagCommander: function (options) {
                // prevent duplication tracking on same category
                var currentCategoryTracked = allCategories ? 'allCategories' : category.id;
                if(currentCategoryTracked !== categoryTracked || options) {
                    categoryTracked = currentCategoryTracked;
                    if (allCategories) {
                        TagCommander.LoadPage('allCategories');
                    } else if (!!category) {
                        var list_products_cat = category.getProducts(true, true, true).pluck('id_product'),
                            id_category = category.id;
                        TagCommander.LoadPage('category', {
                            id_category: id_category,
                            link_rewrite: app.getCategory(id_category).get('link_rewrite'),
                            list_products_cat: list_products_cat
                        });
                    }
                }
            },
            onCategoryChange: function (id_category) {
                if(!(Modernizr.ios || Modernizr.android)){
                    router.navigate(category.getUrl(true), {trigger: false, replace: true});
                    //view.startPageTagCommander();
                }
                view.changeFocusCategory(id_category,true);

                view.initialMetaTitle();

                //
                // TagCommander tracking
                //
                var deltaTime = (new Date()-categoryChangeDelay)
                function TrackPageTagCommander(){
                    resetCategoryChangeDelay();
                    view.startPageTagCommander();
                }
                clearTimeout(categoryChangeTimeout);
                if(deltaTime > _CATEGORY_CHANGE_MIN_DELAY_){
                    TrackPageTagCommander();
                }else{
                    categoryChangeTimeout = setTimeout(TrackPageTagCommander,_CATEGORY_CHANGE_MIN_DELAY_ - deltaTime)
                }
            },
            changeFocusCategory: function(id_category,smooth) {
                var view = this,
                    ul = view.$('ul.listing-categories'),
                    scrollLeft = ul.scrollLeft(),
                    elCat = view.$('li.category-'+id_category),
                    elOffsetLeft = elCat.offset().left,
                    padding = 72,
                    scrollOptions = {
                        left:elOffsetLeft+scrollLeft-padding
                    };
                if(smooth && $('.listing-menu-wrapper').is('.active')){
                    scrollOptions.behavior = 'smooth';
                }
                ul.get(0).scrollTo(scrollOptions);
            },

            toggleNavigationByDesireOnLoad:function(){
                var view = this;
                navigationByDesireAlreadySeen = Cookies.get('navigationByDesireAlreadySeen');
                if (!navigationByDesireAlreadySeen) {
                    view.toggleNavigationByDesireDialog(true)
                    Cookies.set('navigationByDesireAlreadySeen', true, {expire: 30})
                    setTimeout(function(){
                        view.toggleNavigationByDesireDialog(false);
                    },6000);
                }
            },
            toggleNavigationByDesireDialog:function(state){
                var view = this;
                view.$('.listing__navigation-by-desire__dialog').toggleClass('forced',state);
                if(state){
                    // fermeture automatique au bout de 6 secondes
                    clearTimeout(autoCloseDialog);
                    autoCloseDialog = setTimeout(function(){
                        view.toggleNavigationByDesireDialog(false);
                    },6000);
                }
            },
            closeNavigationByDesireDialog:function(e){
                e.preventDefault();
                e.stopPropagation();
                this.toggleNavigationByDesireDialog(false);
            },
            isNavigationByDesireActive:function() {
                return parseInt(app.c('_IS_NAVIGATION_BY_DESIRE_ACTIVE_', 0));
            },
            hoverNavigationByDesireDialog:function(e){
                if(app.isDesktop() && !isNavigationByDesire){
                    this.$('.listing__navigation-by-desire__dialog').toggleClass('hover',e.type.toLowerCase() === 'mouseenter');
                }
            },

            onChangeNavigationByDesireSwitch: function (newValue) {
                if (!app.isMobile() || navigationByDesireAlreadyClicked) {
                    app.scrollTop(0, 300);
                    isNavigationByDesire = newValue === 'yes';
                    var toggle = isNavigationByDesire !== category.isNavigationByDesire();

                    if (toggle) {
                        // si on passe d'un mode à l'autre et que la catégorie n'est pas visible
                        category = getCategoryCollection().firstActiveInContext();
                    }
                    view.render(false);

                    if(toggle){
                        view.setCategoryId(category.id);
                        app.trigger('displayCategory', category.id);
                    }
                } else {
                    var btnSwitchView = view.$('.navigation-by-desire-switch').data('BtnSwitchView');
                    btnSwitchView.setValue('no');
                    this.toggleNavigationByDesireDialog(true)
                    navigationByDesireAlreadyClicked = true
                }
            },

            changeNavigationByDesireVisibility:function(visible) {
                $('.listing__navigation-by-desire--mobile').toggleClass('active',visible)
            },

            onListingFilterChange: function () {
                view.renderContext();
            },

            onCatClick: function () {
                // setTimeout(function () {
                //     view.toggleHead(false);
                // }, 100);
            },

            toggleHead: function (scrolled) {

                //clearTimeout(toggleHeadTimeout);


                //toggleHeadTimeout = setTimeout(function(){
                    view.scrolled = scrolled;
                    view.$el.toggleClass('scrolled', scrolled);
                    view.repositionTop();
                //},1000);

            },

            listingContainerSizeChange: function (e) {
                if (/transform/.test(e.originalEvent.propertyName) && (e.target == listContentEl.get(0))) {
                    app.trigger('listingContainerSizeChange');
                }
            },

            updateProgressBar: function (scrollTop) {
                var scrollRatio = scrollTop / (app.get('docH') - app.get('winH'));
                if(!app.get('scrollLocked')){
                    progressEl.css('width', (scrollRatio * 100) + '%');
                }
            },

            onScroll: function (e, scrollTop) {
                view.scrollTop = scrollTop ? scrollTop : 0;
                if (app.isDesktop() && (!app.get('scrollLocked'))) {

                    var changeSize = true;
                    if ((view.scrollTop == 0) && view.scrolled) {
                        view.toggleHead(false);
                    } else if ((view.scrollTop > 0) && !view.scrolled) {
                        view.toggleHead(true);
                    } else {
                        changeSize = false;
                    }

                    if (changeSize) {
                        view.updateBtnScrollTop(scrollTop);
                    }
                    //view.loadCategoriesBlock();
                }
                if (!Modernizr.touchevents) {
                    view.updateProgressBar(scrollTop);
                }

            },

            updateBtnScrollTop: function (scrollTop) {
                // Afficher ou non le bouton de retour en haut
                var btnBackToTop = view.$('.btn-back-to-top');
                btnBackToTop.toggleClass('active', scrollTop > 100);
            },

            onResize: function () {
                view.repositionTop();
            },

            repositionTop: function () {
                if (app.get('winH') < 850 && view.scrolled) {
                    app.trigger('hideHeader');
                } else {
                    app.trigger('showHeader');
                }
            },

            backToTop: function () {
                $('html, body').scrollTop(0);
            },

            resizeProducts: function (small) {
                //
                view.deactiveList();
                //setTimeout(function () {
                    view.$('.listing-main').toggleClass('s-products', small);
                    view.$('.product-block').toggleClass('s-size', small);
                    view.$('.product-block').toggleClass('m-size', !small);
                    listingMainView.updateBlocksDimensions();
                    view.activeList();
                //}, 200);
            },

            deactiveList: function () {
                view.$('.categories').addClass('inactive');
                view.$('.size-loader').addClass('active');
            },

            activeList: function () {
                view.$('.categories, .size-loader').removeClass('active inactive');
            },

            toggleProductsSize: function (e) {
                var btn = $(e.currentTarget),
                    className = 'icon-cols',
                    isIconCols2 = btn.is('.' + className + '2');
                view.resizeProducts(!isIconCols2);
                btn.toggleClass(className + '2', !isIconCols2).toggleClass(className + '3', isIconCols2);
            },

            initialMetaTitle:function(){
                var title = app.getShopName();
                if(category){
                    title = category.get('titre_seo') || category.getTitle();
                }
                document.title = title;
            },

            // updateQuantity:function(newCart) {
            //     _(newCart.changed.products).each(function(product) {
            //         var productBlock = this.$('.product-block[data-id_product="'+ product.id_product +'"]');
            //             if (!productBlock.length) { return }
            //             var quantityBlock = productBlock.find('.product-block__quantity');
            //
            //             quantityBlock.html(product.quantity > 0 ? product.quantity : '')
            //     })
            // },
            // removeQuantity: function(product) {
            //     var productBlock = this.$('.product-block[data-id_product="'+ product.id +'"]');
            //     if (!productBlock.length) { return }
            //     var quantityBlock = productBlock.find('.product-block__quantity');
            //     quantityBlock.html('');
            // },

            openFilters: function () {
                // app.displayModal(new FiltersView());
                app.displayModal(new FiltersView());
            },

        });

    });

